// Keep vue-print-nb behavior while avoiding its generated inline <style> block.
import print from "vue-print-nb/print/index.js";
import PrintArea from "vue-print-nb/print/packages/printarea.js";

const originalGetHead = PrintArea.prototype.getHead;
PrintArea.prototype.getHead = function () {
  const head = originalGetHead.call(this);
  // External stylesheets are already copied as <link> by vue-print-nb.
  const css = Array.from(document.querySelectorAll("style"))
    .map((element) => element.textContent)
    .join("\n");
  const url = URL.createObjectURL(new Blob([css], { type: "text/css" }));
  // Keep the sheet available while the print iframe loads and is previewed.
  setTimeout(() => URL.revokeObjectURL(url), 10 * 60 * 1000);
  return head.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi,
    `<link rel="stylesheet" href="${url}">`);
};

export default print;
